import { Array, flow, Option, pipe } from 'effect';
import { match, P } from 'ts-pattern';
const extractReductionFromAdjustment = (adjustment) => {
    var _a;
    return pipe(Option.liftPredicate(Array.isArray)((_a = adjustment === null || adjustment === void 0 ? void 0 : adjustment.metadata) === null || _a === void 0 ? void 0 : _a.reductionsBreakdown), Option.map(Array.map((reductionBreakdown) => ({
        attendeeId: match(adjustment.metadata)
            .with({ attendeeId: P.string }, ({ attendeeId }) => attendeeId)
            .with({ attendeeId: [P.string, ...P.array(P.string)] }, ({ attendeeId: [first] }) => first)
            .run(),
        reductionBreakdown
    }))), Option.map(Array.filterMap(({ attendeeId, reductionBreakdown }) => {
        if (typeof reductionBreakdown !== 'object' ||
            reductionBreakdown === null) {
            return Option.none();
        }
        return match({
            ...reductionBreakdown,
            validFrom: 'validFrom' in reductionBreakdown
                ? reductionBreakdown.validFrom
                : null,
            validUntil: 'validUntil' in reductionBreakdown
                ? reductionBreakdown.validUntil
                : null
        })
            .returnType()
            .with({
            id: P.string,
            amount: P.number,
            amountType: P.union('PERCENT', 'FIXED'),
            validFrom: P.union(P.string, P.nullish),
            validUntil: P.union(P.string, P.nullish),
            reductionType: P.union('LICENSED', 'GENDER', 'MINOR', 'GROUP', 'ALL')
        }, ({ id, amount, amountType, reductionType, validFrom, validUntil }) => Option.some({
            id,
            amount,
            amountType,
            validFrom: validFrom ? new Date(validFrom) : null,
            validUntil: validUntil ? new Date(validUntil) : null,
            attendeeId,
            ...match(reductionType)
                .with('GROUP', (reductionType) => ({
                groupId: Number(reductionBreakdown.groupId),
                groupName: '',
                reductionType
            }))
                .with('GENDER', (reductionType) => ({
                gender: reductionBreakdown.gender,
                reductionType
            }))
                .otherwise((reductionType) => ({
                reductionType
            }))
        }))
            .otherwise(() => Option.none());
    })), Option.getOrElse(() => []));
};
const extractReductionFromAdjustments = flow(Array.map(extractReductionFromAdjustment), Array.flatten);
export const CheckoutReductionReadLegacyService = {
    /**
     * Extracts an array of `Reduction` objects from the given `LineItem`'s adjustments.
     *
     * This method processes the `adjustments` property of the provided `lineItem`, filtering for those
     * that contain a `reductionsBreakdown` in their metadata. It then maps each valid reduction breakdown
     * to a `Reduction` object.
     *
     * @param lineItem - The `LineItem` object from which to extract reductions.
     * @returns An array of `Reduction` objects extracted from the line item's adjustments.
     */
    extractReductionFromAdjustments,
    extractReductionFromAdjustment
};
